import React, { useEffect, useState } from "react";
import { GraduationCap, BookOpen, ClipboardList, Eye } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import AIInsightsCard from "@/components/AIInsightsCard";

export default function TeacherDashboard() {
  const [classes, setClasses] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/pedagogy/my-classes").then(({ data }) => {
      setClasses(data.classes || []);
      setSubjects(data.subjects || []);
    }).catch(() => {});
  }, []);

  return (
    <div className="space-y-6" data-testid="teacher-dashboard">
      <div>
        <div className="chip mb-2"><GraduationCap className="h-3 w-3" /><span>Enseignant</span></div>
        <h2 className="font-heading text-3xl sm:text-4xl font-extrabold text-[#1E3A8A] tracking-tight">Mes classes</h2>
        {subjects.length > 0 && (
          <div className="flex flex-wrap gap-1 mt-2">
            {subjects.map(s => <span key={s} className="text-xs px-2 py-0.5 rounded-full bg-green-50 text-[#166534] font-semibold">{s}</span>)}
          </div>
        )}
      </div>

      {/* AI Insights — élèves à risque, plans de soutien */}
      <AIInsightsCard accentColor="#1E3A8A" />

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
        {classes.map((c, i) => (
          <div key={c.id} className="mazid-card p-6" data-testid={`teacher-class-${i}`}>
            <div className="flex items-center gap-3 mb-3">
              <div className="w-11 h-11 rounded-lg bg-[#166534]/10 text-[#166534] flex items-center justify-center"><BookOpen className="h-5 w-5" /></div>
              <div>
                <div className="font-heading font-bold text-lg text-[#1E3A8A]">{c.name}</div>
                <div className="text-xs text-slate-500">{[c.level, c.year].filter(Boolean).join(" · ") || "Classe affectée"}</div>
              </div>
            </div>
            <div className="flex items-center justify-between mt-4 pt-4 border-t border-slate-100">
              <div>
                <div className="text-xs uppercase tracking-wider text-slate-500">Effectif</div>
                <div className="font-heading font-bold text-2xl text-[#0F172A]">{c.students_count}</div>
              </div>
              <div className="flex gap-2">
                <button onClick={() => navigate("/dashboard/notes-classe", { state: { class_name: c.name } })} className="text-xs px-3 py-2 rounded-md border border-[#1E3A8A] text-[#1E3A8A] font-semibold hover:bg-blue-50 gap-1 inline-flex items-center" data-testid={`view-grades-${c.id}`}>
                  <Eye className="h-3 w-3" /> Notes
                </button>
                <button onClick={() => navigate("/dashboard/saisie-notes", { state: { class_name: c.name } })} className="text-xs px-3 py-2 rounded-md bg-[#1E3A8A] text-white font-semibold hover:bg-[#172554] gap-1 inline-flex items-center" data-testid={`enter-grades-${c.id}`}>
                  <ClipboardList className="h-3 w-3" /> Saisir
                </button>
              </div>
            </div>
          </div>
        ))}
        {classes.length === 0 && (
          <div className="col-span-3 text-center text-slate-500 py-12 bg-white rounded-xl border border-slate-200">
            Aucune classe affectée — contactez l&apos;administration ou la scolarité pour définir vos affectations.
          </div>
        )}
      </div>
    </div>
  );
}
